import { lazy } from "react";

const E404 = lazy(() => import("./E404"));

export { E404 };
